// legacy
export const LEGACY_PROVIDER_PRC_URL = 'https://writer.lacchain.net'; // used for tokens
// identity
export const DID_METHOD = process.env.REACT_APP_DID_METHOD;
// credentials
export const SUPPORTED_CHAIN_ID = process.env.REACT_APP_SUPPORTED_CHAIN_ID;
export const RPC_URL = process.env.REACT_APP_RPC_URL;
export const NODE_ADDRESS = process.env.REACT_APP_NODE_ADDRESS;
export const SUPPORTED_PUBLIC_DIRECTORY_VERSION = '1';
export const ON_NOT_FOUND_PUB_KEY_RESOLUTION_METHOD = process.env.REACT_APP_ON_NOT_FOUND_PUB_KEY_RESOLUTION_METHOD;
export const LAC1_DID_REGISTRY = process.env.REACT_APP_LAC1_DID_REGISTRY;
export const LAC_DID_REGISTTRY = process.env.REACT_APP_LAC_DID_REGISTTRY;
export const LAC_DID_NETWORK_IDENTIFIER = process.env.REACT_APP_LAC_DID_NETWORK_IDENTIFIER; // 'openprotest' or 'main'
export const MAILBOX_SERVICE = process.env.REACT_APP_MAILBOX_SERVICE;
export const MAILBOX_DID = process.env.REACT_APP_MAILBOX_DID;
export const DEFAULT_PUBLIC_DIRECTORY_TRUSTED_CONTRACT_ADDRESS = process.env.REACT_APP_DEFAULT_PUBLIC_DIRECTORY_TRUSTED_CONTRACT_ADDRESS;
export const PUBLIC_DIRECTORY_TRUSTED_CONTRACT_ADDRESSES = process.env.REACT_APP_PUBLIC_DIRECTORY_TRUSTED_CONTRACT_ADDRESSES.split(',');
export const DEFAULT_CHAIN_OF_TRUST_CONTRACT_ADDRESS = process.env.REACT_APP_DEFAULT_CHAIN_OF_TRUST_CONTRACT_ADDRESS;
export const TRUSTED_CHAIN_OF_TRUST_CONTRACT_ADDRESSES = process.env.REACT_APP_TRUSTED_CHAIN_OF_TRUST_CONTRACT_ADDRESSES.split(',');
export const DEFAULT_VERIFICATION_REGISTRY_CONTRACT_ADDRESS = process.env.REACT_APP_DEFAULT_VERIFICATION_REGISTRY_CONTRACT_ADDRESS;
export const TRUSTED_VERIFICATION_REGISTRY_CONTRACT_ADDRESS = process.env.REACT_APP_TRUSTED_VERIFICATION_REGISTRY_CONTRACT_ADDRESS.split(
  ',',
);
export const DOMAIN_TYPE = '0001';
export const DOMAIN_VERSION = '0001';
